module.exports = __webpack_public_path__ + "img/all_a_70121.86e48bef.jpg";